import Separator from 'components/common/separator';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import CruiseRescheduleItemCard from './card';
import CruiseCard from './cruise-card';

export default function CruiseItems() {
  const { control } = useFormContext();
  const cruiseSales = useWatch({ control, name: 'cruiseSales' });

  return (
    <>
      <CruiseCard />
      <Separator gap={16} />

      {cruiseSales.map((cs, idx) => (
        <React.Fragment key={cs.id}>
          <CruiseRescheduleItemCard parentIndex={idx} />
          <Separator gap={16} />
        </React.Fragment>
      ))}
    </>
  );
}
